import { render, staticRenderFns } from "./foot.vue?vue&type=template&id=091f8a16&"
import script from "./foot.vue?vue&type=script&lang=js&"
export * from "./foot.vue?vue&type=script&lang=js&"
import style0 from "./foot.vue?vue&type=style&index=0&id=091f8a16&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports